import { getAxiosInstance } from '../configs/axios-config';
import { authDetails } from './auth-details';
var constants = require("../configs/constants");

export const getYears = async () => {
    try {
        let axiosInstance = getAxiosInstance();
        let response = await axiosInstance.get(constants.api.YEAR);
        sessionStorage.setItem('years', JSON.stringify(response.data));
        sessionStorage.setItem('isYearsFetched', true);
        return response.data;
    }
    catch (err) {
        sessionStorage.setItem('isYearsFetched', false);
    }
}

/**
 * Get roles and saved in session storage
 */
export const getRoles = async () => {
    try {
        let axiosInstance = getAxiosInstance();
        let response = await axiosInstance.get(constants.api.ROLE_TYPE);
        sessionStorage.setItem('roles', JSON.stringify(response.data));
        return response.data;
    }
    catch (err) {
        console.log(err)
    }
} 


// WEBPACK FOOTER //
// ./src/helpers/initial-service-calls.js